import React, { Fragment, useContext } from "react";

import { EligibilityContext } from "../../contexts/EligibilityContext";
import Notifications from "./resources/Notifications";
import ExternalFunds from "./resources/ExternalFunds";
import Email from "./resources/Email";

import { notDiseaseFund } from "../../helpers/fund";

const Resources = (props) => {
  const context = useContext(EligibilityContext);

  return (
    <div className="f-scale-body u-richtext">
      {props.status === "closed" && (
        <Fragment>
          <p className="f-h3 u-mb2" style={{ marginTop: 0 }}>
            The fund for {context.state.diseaseFund.name} is closed.
          </p>
          <p class="eligibility-wizard-fund-closed-last-p">This fund is currently closed, but eligible patients can <a id="ga-wizardFundPageLink" href="https://totalassist.org/notify" target="_blank" rel="noopener">sign up to get notified</a> when this fund opens.</p>

          {context.state.diseaseFund.showWaitList && (
            <Fragment>
              {notDiseaseFund(context.state.diseaseFund.groupId) &&
                context.state.role === "patient" && (
                  <Fragment>
                    <Notifications />
                    <hr />
                  </Fragment>
                )}
              {!notDiseaseFund(context.state.diseaseFund.groupId) && (
                <Fragment>
                  <Notifications />
                  <hr />
                </Fragment>
              )}
            </Fragment>
          )}
        </Fragment>
      )}

      {props.status === "notEligible" && (
        <p className="f-h3 u-mb2" style={{ marginTop: 0 }}>
          {context.state.role === "patient" && (
            <Fragment>
              Based on your answers, you are not eligible at this time. If your eligibility changes, please check again.
            </Fragment>
          )}
          {(context.state.role === "provider" ||
            context.state.role === "pharmacy") && (
            <Fragment>
              Based on your answers, the patient is not eligible at this time. If their eligibility changes, please check again.
            </Fragment>
          )}
        </p>
      )}

      {props.status === "waitListOnly" && (
        <Fragment>
          <p className="f-h3 u-mb2" style={{ marginTop: 0 }}>
            The fund for {context.state.diseaseFund.name} is closed.
          </p>
          <p class="eligibility-wizard-fund-closed-last-p">This fund is currently closed and our wait list process has been sunset. <a id="ga-wizardFundPageLink" href="https://totalassist.org/notify" target="_blank" rel="noopener">Sign up to get notified</a> when this fund opens.</p>
        </Fragment>
      )}

      {/* <ExternalFunds /> */}

      {context.state.role === "patient" &&
        context.state.role === "temporary removal" &&
        context.state.supportPrograms.length > 0 && (
          <Fragment>
            <hr />
            <Email />
          </Fragment>
        )}
      
      {(props.status !== "closed" && props.status !== "waitListOnly") && (
        <hr />
      )}

      {(props.status !== "closed" && props.status !== "waitListOnly") && (
        <p className="u-mb2">
          If you still need help, visit{" "}
          <a
            /* this id is used for GA */
            id="ga-wizardFundPageLink"
            href={context.state.diseaseFund.permalink}
          >
            this fund's page
          </a>{" "}
          to learn more about its eligibility requirements or contact us using the number below.
        </p>
      )}
    </div>
  );
};

export default Resources;
